window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

repos.casinoThemesRepo = function () {
  
    var list = function (showOnlyActive) {
        var url = 'api/casinothemes?c=' + casino.config.guiCacheVerzija;
        if (showOnlyActive)
            url += '&showOnlyActive=' + showOnlyActive;

        return fetch(url, {
            credentials: repos.base.credentials
        })
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);
    };

    return {
        list: list
    }

}();